module.exports = __webpack_public_path__ + "static/media/dark_logo.c4398405.png";